import * as stylex from '@stylexjs/stylex';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { GlobalsCompanyInfo, GlobalsFooterNav, GlobalsHeaderNav, GlobalsSocials } from '@/tina/__generated__/types';
import React from 'react';
import { layout } from '../../styles/layout';
import { HeaderNav } from '../MainNavigation';
import { MobileMenuProvider } from '../MainNavigation/ClientComponents';
import { Action, ActionButtons } from '../Buttons/ActionButtons';
import '../../styles/tokens.stylex';
import { fontSizes } from '../../styles/tokens.stylex';
import { GlobalsQueryData } from '../../lib/tinaQueries';
interface LayoutProps {
  children: React.ReactNode;
  globalData: GlobalsQueryData;
  showNavs?: boolean;
  headerActions?: Action[];
  headerColor?: 'light' | 'dark';
  headerElevation?: boolean;
  hideHeader?: boolean;
}
export function PageLayout({
  children,
  globalData,
  showNavs,
  headerActions,
  headerColor,
  headerElevation,
  hideHeader
}: LayoutProps) {
  return <MobileMenuProvider>
      <Header color={headerColor} elevation={headerElevation} hideHeader={hideHeader} navigation={<>
            {showNavs && <HeaderNav data={globalData.globals.headerNav as GlobalsHeaderNav[]} />}
            {headerActions && !showNavs && <ActionButtons actions={headerActions} styles={sx.actionButtonStyles} size="compact" args={{
        componentName: 'LandingPageHeader'
      }} />}
          </>} />
      <main {...stylex.props([layout.background, sx.mainAnchor])}>
        {children}
      </main>
      <Footer navigation={showNavs ? globalData.globals.footerNav as GlobalsFooterNav[] : undefined} companyInfo={globalData.globals.companyInfo as GlobalsCompanyInfo} socials={globalData.globals.socials as GlobalsSocials[]} showTelephoneNumber={showNavs} bottomSpacer={!showNavs} />
    </MobileMenuProvider>;
}
const sx = {
  actionButtonStyles: {
    kGuDYH: "x1tnq2d2",
    $$css: true
  },
  mainAnchor: {
    k48fcG: "xrb3h3b",
    $$css: true
  }
};